import styled, { keyframes, css } from "styled-components";
import theme from "styled-theming";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import { isTrue } from "common/src/boolean-parser";
import loadingDots from "./loading_dots.gif";
import { buttonTheme } from "../dbot-button/DbotButtonStyles";

const chatDots = keyframes`
  0% {
    height:30px;
    width:50px;
    transform: scale(1);
  }
  80% {
    height:30px;
    width:50px;
    transform: scale(1.5);
  }
  100% {
   height:0;
   width:0;
    transform: scale(0);
    display: none;
  }
`;

const chatBubblePop = keyframes`
  0% {
    transform: scale(0);
  }
  50% {
    height:auto;
    transform: scale(1.03);
  }
  100% {
    width:auto;
    transform: scale(1);
  }
`;

const fadeIn = keyframes`
  from {
    transform: scale(.25);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const buttonClient = theme("badgesLayout", {
  standalone: css`
    margin-left: -60px;
  `,
});

export const InvestInput = styled.a`
  background: ${(props) => props.theme.themeGlobal.secondary};
  background-color: ${(props) =>
    props.theme.themeGlobal.dbotInvestButtonColor
      ? props.theme.themeGlobal.dbotInvestButtonColor
      : props.theme.themeGlobal.main};
  background-image: ${(props) =>
    isTrue(props.theme.themeGlobal.dbotInvestButtonLogo) ? `url(${MEDIA_URL}/branding/logo_dbot.png)` : "none"};
  background-size: 140px;
  background-position: center;
  background-repeat: no-repeat;
  border: 0;
  display: inline-block;
  margin: 0;
  text-decoration: none;
  min-width: 150px;
  min-height: 50px;
  text-transform: uppercase;
  line-height: 30px;
  ${buttonClient};
  color: ${(props) => (isTrue(props.theme.themeGlobal.dbotInvestButtonLogo) ? "transparent" : "#fff")};
  font-weight: bold;

  &.link-view {
    border-radius: 5px 5px 5px 0;
    padding: 10px;
    font-size: 18px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  &.link-view:link,
  &.link-view:visited,
  &.link-view:hover,
  &.link-view:active {
    color: ${(props) => (isTrue(props.theme.themeGlobal.dbotInvestButtonLogo) ? "transparent" : "#fff")};
  }
  &:hover {
    opacity: 0.8;
  }
`;

export const Talktext = styled.div`
  max-width: 75%;
  padding: 10px 12px;
  line-height: 1.3em;
  color: ${(props) => props.theme.themeGlobal.textColor};
  display: inline-block;
  border-radius: 10px 10px 10px 0;
  margin: 0;
  font-family: ${(props) => `${props.theme.themeGlobal.font}, 'Trebuchet MS', sans-serif`};

  &.rightBubble {
    background: ${(props) => props.theme.themeGlobal.dbotAnswerPicker};
    background: ${(props) => props.theme.themeGlobal.dbotAnswerColor};
    color: ${(props) => props.theme.themeGlobal.dbotAnswerTextColor};
    float: right;
    margin-right: 5px;
    border-radius: 15px 15px 0 15px;
    padding: 9px;
    text-align: left;
    position: relative;
    ${buttonTheme};
  }
  &.rightBubble .gif-view {
    float: right;
    max-height: 100px;
    width: auto;
  }
`;

export const LeftBubbleWrapper = styled.div`
  margin: 5px auto;
  padding-right: 5px;
  padding-left: 5px;
  display: block;
  width: 50px;
  float: left;
  clear: both;
  text-align: left;
  width: 100%;
  max-width: 100%;
  font-family: ${(props) => `${props.theme.themeGlobal.font}, 'Trebuchet MS', sans-serif`};
  &.animated {
    float: none;
    transform: scale(0);
    animation: ${chatBubblePop} 1.5s ease-in-out;
    animation-fill-mode: both;
    animation-delay: ${(props) => props.wait}s;
    transform-origin: 0 50% 0;
  }
  > form {
    text-align: center;
  }
  &.with-logo {
    background-image: ${(props) =>
      isTrue(props.theme.themeGlobal.dbotLeftBubbleLogo) ? `url("${MEDIA_URL}/common/chatLogo.svg")}` : "none"};
    background-position: left 97%;
    background-repeat: no-repeat;
    vertical-align: bottom;
    margin-bottom: 8px;
    background-size: 18px;
  }
  > .with-logo img {
    margin-left: 33px;
  }
  > .with-logo .talktext,
  > .without-logo {
    margin-left: 25px;
  }
  > .without-logo img {
    margin-left: 8px;
  }
  &.with-logo .gif .imageloader img,
  &.without-logo .gif .imageloader img {
    max-width: 100%;
    border-radius: 5px 5px 5px 0;
    height: auto;
  }
`;

export const TypingBubble = styled.div`
  background-image: url(${loadingDots});
  display: inline-block;
  width: 50px;
  height: 30px;
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px 10px 0 10px;
  animation: ${chatDots} 1s ease-in-out;
  animation-delay: ${(props) => props.duration}s;
  animation-fill-mode: both;
  transform-origin: 0 50% 0;
  line-height: 1.3em;
  color: #383737;
  border-radius: 10px 10px 10px 0;
  background-color: #e7e8e7;
  background-color: ${(props) => props.theme.themeGlobal.bgNeutral};
  float: left;
  position: ${(props) => (isTrue(props.theme.themeGlobal.dbotLeftBubbleLogo) ? "absolute" : "static")};
  bottom: 0;
  left: 5px;
  margin-left: ${(props) => (isTrue(props.theme.themeGlobal.dbotLeftBubbleLogo) ? "20px" : "0")};
`;

export const LeftBubbleText = styled.div`
  max-width: 75%;
  padding: 10px 12px;
  line-height: 1.3em;
  color: #383737;
  color: ${(props) => props.theme.themeGlobal.textColor};
  display: inline-block;
  border-radius: 10px 10px 10px 0;
  background: #e7e8e7;
  background: ${(props) => props.theme.themeGlobal.bgNeutral};
  float: left;
  margin-left: ${(props) => (isTrue(props.theme.themeGlobal.dbotLeftBubbleLogo) ? "20px" : "0")};
  &.gif {
    max-width: 250px;
  }
  &.youtube {
    width: 100% !important;
    height: auto !important;
    max-width: 200px !important;
    min-width: 200px !important;
  }
  &.animated {
    animation: ${fadeIn} 0.5s ease-in-out;
    animation-delay: ${(props) => props.wait}s;
    animation-fill-mode: both;
    float: none;
  }
  &.EXAM,
  &.EXTRA_EXAM {
    background: ${(props) => props.theme.themeGlobal.examModeColor};
  }
  &.iframe {
    padding: 0;
    max-width: 100%;
  }
`;

export const RightBubbleWrapper = styled.div`
  margin: 15px auto 5px auto;
  height: auto;
  padding-right: 5px;
  padding-left: 5px;
  animation: ${fadeIn} 1s;
  display: inline-block;
  clear: both;
  display: block;
  width: 100%;
  min-height: 40px;
  > img {
    border-radius: 10px 10px 0 10px;
    display: block;
    min-height: 10px;
    background-color: transparent;
    float: right;
    height: 100%;
  }
`;

export const Video = styled.div`
  position: relative;
  border-radius: 10px 10px 10px 0;
  animation: ${fadeIn} 1s;
  padding-bottom: 56.25%;
  padding-top: 25px;
  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
